export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Type de plan\",\n    \"label_other\": \"{{count}} types de plans\"\n}\n"